'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _reactRedux = require('react-redux');

var _ScreenMessage = require('./ScreenMessage');

var _ScreenMessage2 = _interopRequireDefault(_ScreenMessage);

var _RemoveScreenMessageAction = require('./actions/RemoveScreenMessageAction');

var _Notification = require('../../managewidgets/components/notification/Notification');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    onClose: function onClose() {

      if (props.status === _Notification.NotificationStatus.INFORMATIONAL) {
        dispatch((0, _RemoveScreenMessageAction.removeInformationalScreenMessage)(props.message.value, props.screenKey));
      } else if (props.status === _Notification.NotificationStatus.WARNING) {
        dispatch((0, _RemoveScreenMessageAction.removeWarningScreenMessage)(props.message.value, props.screenKey));
      } else if (props.status === _Notification.NotificationStatus.SUCCESSFUL) {
        dispatch((0, _RemoveScreenMessageAction.removeSuccessfulScreenMessage)(props.message.value, props.screenKey));
      } else if (props.status === _Notification.NotificationStatus.ERROR) {
        dispatch((0, _RemoveScreenMessageAction.removeErrorScreenMessage)(props.message.value, props.screenKey));
      }
    }
  };
};

var ScreenMessageContainer = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(_ScreenMessage2.default);

exports.default = ScreenMessageContainer;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screenmessage/ScreenMessageContainer.js
// module id = 354
// module chunks = 10